<div class="pt-4">
  <app-input-multi-atom
    [type]="'checkbox'"
    [value]="forceType(value)"
    [label]="title"
    (valueEmitter)="onValueChange($event)"
  ></app-input-multi-atom>
</div>
